import React from 'react';
import IconButton from './IconButton';

const BackButton = ({ disabled, iconOnly, onClick }) => (
  <IconButton
    className="aridhia-back-button"
    disabled={disabled}
    icon
    iconName="chevron left"
    iconOnly={iconOnly}
    labelPosition="left"
    messageId="actions.back"
    onClick={onClick}
  />
);

export default BackButton;
